import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
    return (
        <div className='home-container'>
           
                <img className='home-img' src="https://cdn.thespaces.com/wp-content/uploads/2020/01/Gymshark-hero-crop.jpg"/>
                <p className="missionStatement">Donec ac odio tempor orci dapibus ultrices in iaculis. Donec massa sapien faucibus et molestie ac feugiat. Amet porttitor eget dolor morbi non arcu. Ultrices vitae auctor eu augue ut lectus arcu.             
                Tellus mauris a diam maecenas sed enim ut sem viverra. Bibendum est ultricies integer quis. 
                Tellus cras adipiscing enim eu turpis egestas pretium. Netus et malesuada fames ac turpis egestas integer eget aliquet. Facilisi cras fermentum odio eu feugiat pretium nibh ipsum consequat.
                Diam quis enim lobortis scelerisque fermentum dui. Tempus imperdiet nulla malesuada pellentesque elit eget gravida. Ut enim blandit volutpat maecenas volutpat blandit aliquam etiam.
                </p>
            </div>
    )
}

export default Home

//Bri, I think it would be great if we could have a mission statement of sorts like 
//Here at WERKIT, we believe in spreading positivity and encouraging our patrons
//to enjoy working out by making a customizable routine or following one of our many
//routines posted by other patrons. 
//and then partway down, putting
//It's WERKIT with an E because we put Excitement in Working out!
//colorwise, I am thinking that we can put the page in a color scheme of greens/grays/whites?